import styled from '@emotion/styled'
import * as React from 'react'
const API_KEY = window.lego.config.GOOGLE_MAPS_KEY

const MapContainer = styled.div`
  height: 140px;
`

interface IProps {
  latitude: number
  longitude: number
}

export default function Map(props: IProps) {
  const { latitude, longitude } = props
  const location = latitude.toString() + ',' + longitude.toString()

  const url = new URL('https://maps.googleapis.com/maps/api/staticmap')

  url.searchParams.set('size', '370x140')
  url.searchParams.set('zoom', '14')
  url.searchParams.set('key', API_KEY)

  return (
    <MapContainer>
      <img src={url.toString() + getMarkerParam(location, 'bottom')} />
    </MapContainer>
  )
}

// We have to use this custom function because url.SearchParams.set
// auto-encodes the colons in this string as different characters
// but Google Maps Static API needs the colons to add params to the marker itself
function getMarkerParam(location: string, anchor: string): string {
  const divider = '%7C'
  const iconURL =
    'https://ucarecdn.com/296486c9-b2b9-429e-b025-5705a9cd0d76/-/scale_crop/64x64/center/'

  return '&markers=' + 'anchor:' + anchor + divider + 'icon:' + iconURL + divider + location
}
